<template>
  <layout-basic>
    <v-container fluid pa-10>
      <v-row>
        <v-col md="6" class="text-left">
          <h2>Courses</h2>
          <courses-widget :courses="courses" :mini="true"></courses-widget>
        </v-col>
        <v-col md="6">
          <h2 class="text-left">Activity</h2>
          <activity-widget
            :total_courses="total_courses"
            :total_in_progress_courses="total_in_progress_courses"
            :total_completed_courses="total_completed_courses"
          ></activity-widget>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" class="text-right">
          <v-btn color="secondary" outlined to="/courses">View All Courses</v-btn>
        </v-col>
        <v-col md="6" class="text-right">
          <v-btn color="secondary" outlined to="/profile/activity">View Profile</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" class="text-left">
          <h2>Playlists</h2>
          <channels-widget :channels="channels"></channels-widget>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" class="text-right">
          <v-btn color="secondary" outlined to="/playlists">View All Playlists</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>
<script>
import LayoutBasic from "@/layouts/Dashboard";
import ChannelsWidget from "@/components/authenticated/dashboard/Channelswidget";
import ActivityWidget from "@/components/authenticated/dashboard/Activitywidget";
import CoursesWidget from "@/components/authenticated/dashboard/Courseswidget";
import userAPI from "@/api/user.js";

export default {
  name: "Dashboard",
  components: {
    LayoutBasic,
    ChannelsWidget,
    ActivityWidget,
    CoursesWidget
  },
  data() {
    return {
      channels: [],
      courses: [],
      activities: [],
      total_courses: 0,
      total_in_progress_courses: 0,
      total_completed_courses: 0,
      params: "?include=dashboardChannels,dashboardCourses,activityWidget"
    };
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    getProfile() {
      userAPI.getProfile(this.params).then(response => {
        this.courses = response.data.data.dashboardCourses.data;
        this.channels = response.data.data.dashboardChannels.data;
        this.total_completed_courses =
          response.data.data.total_completed_courses;
        this.total_courses = response.data.data.total_courses;
        this.total_in_progress_courses =
          response.data.data.total_in_progress_courses;
        if(response.data.data.role_id==4) {
          this.$store.dispatch("logout").then(() => {
            localStorage.removeItem('todos');
            this.$router.push("/login");
          });
        }
      });
    }
  }
};
</script>
<style>
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  width: 100%;
  right: 20px;
  bottom: 0;
}
</style>
